import React, { useState } from "react";
import emailjs from "@emailjs/browser";

export default function Contact(props) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({
    type: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setStatus({
      type: "",
      message: "",
    });

    try {
      await emailjs.send(
        "service_9nj76tb",
        "template_ekbb2xp",
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
          to_email: "kohliarjun823@gmail.com",
        },
        "zoSm2l0IrKgKtLABb"
      );

      setStatus({
        type: "success",
        message:
          "Thank you! Your message has been sent successfully. I'll get back to you soon.",
      });

      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Email sending failed:", error);

      setStatus({
        type: "error",
        message:
          "Sorry, something went wrong. Please try again or contact me directly by email.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact_us">
      <div className="container">
        <div className="row">
          <div className="col-md-10 offset-md-1">
            <div
              className={`contact_inner bg-${
                props.mode === "light" ? "light" : "light3"
              }`}
            >
              <div className="row">
                <div className="col-md-9">
                  <div className="contact_form_inner">
                    <div
                      className={`contact_field bg-${
                        props.mode === "light" ? "light" : "light3"
                      }`}
                    >
                      <span className="contact_label">
                        GET IN TOUCH
                      </span>

                      <h3>Let's Work Together</h3>

                      <p>
                        Have a project, opportunity, or idea in mind? Send me
                        a message, and I'll get back to you as soon as
                        possible.
                      </p>

                      <form onSubmit={handleSubmit}>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className={`form-control bg-${
                            props.mode === "light" ? "light" : "dark2"
                          } text-${
                            props.mode === "light" ? "dark" : "light"
                          } mb-4`}
                          placeholder="Your Name"
                          required
                        />

                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={`form-control bg-${
                            props.mode === "light" ? "light" : "dark2"
                          } text-${
                            props.mode === "light" ? "dark" : "light"
                          } mb-4`}
                          placeholder="Your Email Address"
                          required
                        />

                        <input
                          type="text"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          className={`form-control bg-${
                            props.mode === "light" ? "light" : "dark2"
                          } text-${
                            props.mode === "light" ? "dark" : "light"
                          } mb-4`}
                          placeholder="Subject"
                          required
                        />

                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          className={`form-control bg-${
                            props.mode === "light" ? "light" : "dark2"
                          } text-${
                            props.mode === "light" ? "dark" : "light"
                          } mb-4`}
                          placeholder="Tell me about your project or opportunity..."
                          rows="5"
                          required
                        ></textarea>

                        <button
                          type="submit"
                          className="btn btn-primary2"
                          disabled={loading}
                        >
                          {loading ? "Sending..." : "Send Message"}
                        </button>

                        {status.message && (
                          <p
                            className={`form-status ${
                              status.type === "success"
                                ? "success"
                                : "error"
                            }`}
                          >
                            {status.message}
                          </p>
                        )}
                      </form>
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="right_conatct_social_icon">
                    <div className="socil_item_inner d-flex gap-3 justify-content-center pt-2">
                      <a
                        className="text-white"
                        href="https://github.com/arjun-kohli95"
                        rel="noreferrer"
                        target="_blank"
                        aria-label="GitHub"
                      >
                        <i className="fab fa-github"></i>
                      </a>

                      <a
                        className="text-white"
                        href="https://www.linkedin.com/in/arjun-singh-200797362"
                        rel="noreferrer"
                        target="_blank"
                        aria-label="LinkedIn"
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </a>

                      <a
                        className="text-white"
                        href="mailto:kohliarjun823@gmail.com"
                        aria-label="Email"
                      >
                        <i className="fas fa-envelope"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-white contact_info_sec">
                <h4>Contact Information</h4>

                <div className="d-flex info_single align-items-center">
                  <i className="fas fa-headset"></i>
                  <span>+91 9990031433</span>
                </div>

                <div className="d-flex info_single align-items-center">
                  <i className="fas fa-envelope-open-text"></i>
                  <span>kohliarjun823@gmail.com</span>
                </div>

                <div className="d-flex info_single align-items-center">
                  <i className="fas fa-map-marked-alt"></i>
                  <span>New Delhi, India</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}